/*
 * @Author: Teemo Ding
 * @Date: 2021-11-01 15:05:56
 * @LastEditTime: 2021-11-01 15:27:29
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/logistics/pickPackSetting.ts
 */
import { get, post } from 'src/tools/server';

// 获取页面country/region 和phone 的area 的接口
export const getPickPackSetting = (warehouseUuid) => {
  return get<any>(
    `/portal/setting/store/logistics/pickPackSetting/${warehouseUuid}`,
    {},
  );
};

export const savePickPackSetting = (data) => {
  return post<any>(
    `/portal/setting/store/logistics/pickPackSetting`,
    data || {},
    {},
  );
};
